document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.subcategories-list.grabbing').forEach((slider) => {
    let isDown = false
    let startX
    let scrollLeft
    let isScrolling = false

    slider.addEventListener('mousedown', (e) => {
      isDown = true
      startX = e.pageX - slider.offsetLeft
      scrollLeft = slider.scrollLeft
      isScrolling = false
    })

    slider.addEventListener('mouseleave', () => isDown = false)
    slider.addEventListener('mouseup', () => isDown = false)

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - slider.offsetLeft
      const walk = x - startX
      slider.scrollLeft = scrollLeft - walk

      if (Math.abs(walk) > 5) {
        isScrolling = true
      }
    })

    slider.addEventListener('click', (e) => {
      if (isScrolling) {
        e.preventDefault()
        isScrolling = false
      }
    }, true)
  })
})
